import { primaryFiltersInModal, subcategoryFields } from './config/configCategories';

export const getOptionLabels = (publicData, fieldConfig) => {
  const { categoryLevel1 } = publicData;
  const relevantFields = subcategoryFields[categoryLevel1] || [];
  const labels = [];

  relevantFields.forEach(fieldKey => {
    const selectedOptions = publicData[fieldKey] || [];
    const field = fieldConfig.find(f => f.key === fieldKey);

    if (field && field.enumOptions) {
      selectedOptions.forEach(option => {
        const enumOption = field.enumOptions.find(eo => eo.option === option);
        if (enumOption) {
          labels.push(enumOption.label);
        }
      });
    }
  });

  return labels;
};

export const countAppliedFilters = currentParams => {
  return primaryFiltersInModal.filter(key => key in currentParams).length;
};
